import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Text } from 'pcln-design-system'

const InlineAd = ({ gaIndex, adId, className }) => (
  <li className='ad' data-testid='inline-ad' data-ga-index={gaIndex}>
    <section>
      <Text
        fontSize={0}
        className='ad-heading'
        color='text.light'
        textAlign='center'
      >
        Advertisement
      </Text>
      <Flex justifyContent='center' className='pcln-gpt-dart-ad'>
        <div className={className} id={adId} data-testid={className} />
      </Flex>
    </section>
  </li>
)

InlineAd.propTypes = {
  adId: PropTypes.string,
  gaIndex: PropTypes.number,
  className: PropTypes.string,
}

export { InlineAd }
